// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/heading/heading.scss
 ** module id = 107
 ** module chunks = 0 1
 **/